import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { PURGE } from "redux-persist"
import { ChatEvent } from "./messagesSlice"
import { RootState } from "./store"

export type ForeignChatActivity = {
  status: "loading" | "ready" | "denied"
  /** ISO stamp of the last archived message, when we could read it. */
  lastMessageAt?: string
  /** The event itself, so the row can preview it the way the plain list does.
   * Absent when the archive's last entry was something with nothing to show. */
  lastEvent?: ChatEvent
}

export type ForeignChatActivityState = Record<string, ForeignChatActivity>

const initialState: ForeignChatActivityState = {}

export const foreignChatActivitySlice = createSlice({
  name: "foreignChatActivity",
  initialState,
  reducers: {
    // Rooms already answered for stay as they are: one archive query per room
    // per session is enough.
    foreignActivityRequested: (state, action: PayloadAction<string[]>) => {
      action.payload.forEach((jid) => {
        if (!state[jid]) state[jid] = { status: "loading" }
      })
    },
    setForeignActivity: (
      state,
      action: PayloadAction<{
        jid: string
        lastMessageAt?: string
        lastEvent?: ChatEvent
      }>,
    ) => {
      state[action.payload.jid] = {
        status: "ready",
        lastMessageAt: action.payload.lastMessageAt,
        lastEvent: action.payload.lastEvent,
      }
    },
    foreignActivityDenied: (state, action: PayloadAction<string>) => {
      state[action.payload] = { status: "denied" }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState)
  },
})

export const selectForeignChatActivity = (state: RootState) =>
  state.foreignChatActivity

export const {
  foreignActivityRequested,
  setForeignActivity,
  foreignActivityDenied,
} = foreignChatActivitySlice.actions

export default foreignChatActivitySlice.reducer
